// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ds3i","comment":"styles_comment__3MgwW"};